import * as React from 'react';
/**
 * @hidden
 */
export var TableKeyboardNavigationContext = React.createContext(undefined);
TableKeyboardNavigationContext.displayName = 'KendoReactTableKeyboardNavigationContext';
